import { render } from "./ImageTagFilter.vue?vue&type=template&id=d504c382&scoped=true"
import script from "./ImageTagFilter.vue?vue&type=script&lang=js"
export * from "./ImageTagFilter.vue?vue&type=script&lang=js"

import "./ImageTagFilter.vue?vue&type=style&index=0&id=d504c382&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d504c382"]])

export default __exports__